/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type GetStakingOverviewQueryVariables = Types.Exact<{
	filter?: Types.InputMaybe<Types.AssetConfigFilter>;
	order?: Types.InputMaybe<Array<Types.AssetConfigOrder> | Types.AssetConfigOrder>;
}>;

export type GetStakingOverviewQuery = {
	__typename?: "Query";
	hasHistory: boolean;
	statistics: { __typename?: "StatisticsResponse"; nonStakedAssetsCount: number };
	assetConfig: {
		__typename?: "AssetConfigResponse";
		stakingEnabled?: boolean | null;
		enabledForUserCountry?: boolean | null;
		assets?: Array<{
			__typename?: "StakeableAsset";
			assetId: string;
			availability: string;
			yearlyInterest: number;
			stakingType: Types.StakingType;
			unboundPeriod?: number | null;
			isAutoStakingEnabled: boolean;
			minStakingAmount: { __typename?: "CurrencyAmount"; value: string };
		}> | null;
	};
	lifetimeRewards: Array<{
		__typename?: "LifetimeRewards";
		asset: { __typename?: "StakeableAsset"; assetId: string };
		rewardsAmount: { __typename?: "Balance"; asset: { __typename?: "CurrencyAmount"; value: string } };
	}>;
	balances: Array<{
		__typename?: "StakingBalance";
		asset: { __typename?: "StakeableAsset"; assetId: string; stakingType: Types.StakingType };
		stakedAmount: { __typename?: "CurrencyAmount"; value: string };
	}>;
};

export const GetStakingOverviewDocument = gql`
	query getStakingOverview($filter: AssetConfigFilter, $order: [AssetConfigOrder!]) {
		statistics {
			nonStakedAssetsCount
		}
		assetConfig(filter: $filter, order: $order) {
			stakingEnabled
			enabledForUserCountry
			assets {
				assetId
				availability
				yearlyInterest
				minStakingAmount {
					value
				}
				stakingType
				unboundPeriod
				isAutoStakingEnabled
			}
		}
		lifetimeRewards {
			asset {
				assetId
			}
			rewardsAmount {
				asset {
					value
				}
			}
		}
		balances {
			asset {
				assetId
				stakingType
			}
			stakedAmount {
				value
			}
		}
		hasHistory
	}
`;

@Injectable({
	providedIn: "root"
})
export class GetStakingOverviewGQLService extends Apollo.Query<
	GetStakingOverviewQuery,
	GetStakingOverviewQueryVariables
> {
	document = GetStakingOverviewDocument;
	client = "staking";
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
